import ROUTES from './routes';
import { MENU, TITLE } from './strings';
import { IDS } from './ids';

export const LANG = 'en';
export const DESCRIPTION = { id: 'general.description' };
export const SLOGAN_PRIMARY = { id: 'general.slogan.primary' };
export const SLOGAN_SECONDARY = { id: 'general.slogan.secondary' };

export const DEFAULT_COUNTRY = 'USA';

export const getNavConfig = (
  formatMessage,
  dashboardAccess,
  id,
  isProvider,
) => {
  const menu = [
    {
      href: `${ROUTES.HEALTHBOARD}/${id}/${ROUTES.HEALTHBOARD_HOME}`,
      id: isProvider ? IDS.NAV_BAR.HEALTH_BOARD : IDS.NAV_BAR.HOME,
      title: isProvider
        ? formatMessage(MENU.healthboard)
        : formatMessage(MENU.home),
    },
    ...(!isProvider && [
      {
        href: ROUTES.PATIENT_HEALTHBOARD,
        id: IDS.NAV_BAR.HEALTH_BOARD,
        title: formatMessage(MENU.healthboard),
      },
    ]),
    {
      href: ROUTES.COMMUNITIES,
      id: IDS.NAV_BAR.COMMUNITIES,
      title: formatMessage(MENU.communities),
    },
    {
      href: ROUTES.MESSAGES,
      id: IDS.NAV_BAR.MESSAGES,
      title: formatMessage(MENU.messages),
    },
    {
      href: ROUTES.CIRCLES,
      id: IDS.NAV_BAR.CIRCLES,
      title: formatMessage(MENU.myCircles),
    },
  ];

  const dashboardOptions = {
    href: ROUTES.DASHBOARD.slice(1),
    id: IDS.NAV_BAR.DASHBOARD,
    title: formatMessage(MENU.dashboard),
  };

  return dashboardAccess ? [...menu, dashboardOptions] : [...menu];
};

export const getTitle = formatMessage => formatMessage(TITLE);
export { TITLE };

export const COMMUNITIES_ACCESS_LEVELS = {
  READ_AND_POST: 'read_and_post',
  READ_ONLY: 'read_only',
  READ_AND_POST_WITH_APPROVAL: 'read_and_post_with_approval',
};

export const COMMINITY_APPROVAL_STATUS_PENDING = 'pending';

export const COMMUNITIES_USER_ROLES = {
  MODERATOR: 'moderator',
  MEMBER: 'member',
};

export const COMPLAINT_TYPE = {
  POST: 'post',
  COMMENT: 'comment',
  COMMUNITY: 'community',
};

export const EDIT_COMMUNITY_VALIDATION_RULES = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 32,
  DESCRIPTION_MAX_LENGTH: 2000,
};

export const ACTIVITY_TYPES = {
  NOTIFICATIONS: 'notifications',
  JOIN_REQUESTS: 'join_requests',
  MEMBER_INVITATIONS: 'member_invitations',
};

export const DISCOVERY_LIST_TYPES = {
  ORGANIZATION: 'organization',
  GLOBAL: 'global',
};

export const COMMUNITY_BTN_ACTIONS = {
  ACCEPT: 'accept',
  JOIN: 'join',
  DECLINE: 'decline',
};

export const ORGANIZATION_COMMUNITIES_NUMBER_MAX = 8;

export const PROFILE_SECTIONS = {
  EMERGENCY_CONTACT: 'emergency_contact',
};

export const IMAGE_ALLOWED_FORMATS = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  '.jpeg',
  '.jpg',
  '.png',
];

export const TASK_DOCUMENTS_FORMATS = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
];

export const TASK_FILE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'pdf'];

export const MAX_TASK_ATTACHMENT_SIZE_ALLOWED = 32;

export const DOCUMENT_ALLOWED_FORMATS = ['application/pdf', 'text/xml'];

export const DOCUMENTATION_TYPES = {
  CARD_1: 'insurance_card_1',
  CARD_2: 'insurance_card_2',
  DRIVER_LICENCE: 'driver_licensce',
};

export const INSURANCE_CARD_SIDE = {
  FRONT: 'front_side',
  BACK: 'back_side',
};

export const RECORD_TYPE = {
  DOCUMENT: 'Document',
  PATIENT_INSURANCE: 'PatientInsurance',
};

export const OCR_CONTEXT = {
  INSURANCE_CARD: 'insurance_card',
};

export const SURVEYS_LIST_TYPE = {
  UPCOMING: 'upcoming',
  RESULTS: 'results',
};

export const SURVEYS_STATUS_TYPE = {
  IN_PROGRESS: 'in_progress',
  STARTED: 'started',
};
export const FIELDS_TYPE = {
  SELECT: 'select',
  IMAGE: 'image',
  DATE: 'date',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
  TEXT: 'text',
  CUSTOM_TIME_PICKER: 'customTimePicker',
  MOBILE_PHONE: 'mobilePhone',
};

export const DEPENDENT_ROLES = {
  PARENT: 'parent',
  GUARDIAN: 'guardian',
  PROXY: 'proxy',
};

export const EMPTY_ROLE = 'none';

export const CIRCLE_TYPES = {
  FAMILY_CIRCLE: 'family_circle',
  PROVIDER_CIRCLE: 'provider_circle',
};

export const POPOVER_MENU_ITEMS = {
  CHANGE_ROLE: 'changeRole',
  UNASSIGN: 'unassign',
  INVITE_MEMBER: 'inviteMember',
  REMOVE_MEMBER: 'removeMember',
  REMOVE_FROM_COMMUNITY: 'removeFromCommunity',
  CANCEL_PENDING_INVITATION: 'cancelPendingInvitation',
  INVITE_PATIENT: 'invitePatient',
  REINVITE_PATIENT: 'reinvitePatient',
};

export const APPOINTMENT_INSPECTION = {
  CONSENT: 'consent_form',
  PROFILE: 'profile_form',
  DOCUMENTS: 'documents_form',
  LOCAL_PROFILE: 'local_appointment_profile_form',
};

export const APPOINTMENT_STATUSES = {
  DRAFT: 'Draft',
  WAITING: 'Waiting',
  PENDING: 'Pending',
  IN_LINE: 'In Line',
  ARRIVED: 'Arrived',
  NO_SHOW: 'No show',
  UPCOMING: 'Upcoming',
  CANCELED: 'Canceled',
  DECLINED: 'Declined',
  COMPLETED: 'Completed',
  TREATMENT: 'Treatment',
  SCHEDULED: 'Scheduled',
  CHECKED_IN: 'Checked-In',
  IN_PROCESS: 'In Process',
  DISCHARGED: 'Discharged',
  REGISTERED_WAITING: 'Registered & Waiting',
};

export const COMPLETED_APPOINTMENT_STATUSES = [
  APPOINTMENT_STATUSES.NO_SHOW,
  APPOINTMENT_STATUSES.CANCELED,
  APPOINTMENT_STATUSES.DECLINED,
  APPOINTMENT_STATUSES.COMPLETED,
];

export const PAYMENT_STATUSES = {
  UNPAID: 'unpaid',
  PENDING: 'pending',
  PAID: 'paid',
  FAILED: 'failed',
  VOIDED: 'voided',
};

export const FAILED_PAYMENT_STATUSES = [
  PAYMENT_STATUSES.FAILED,
  PAYMENT_STATUSES.VOIDED,
];

export const TODO_STATUSES = {
  CANCELED: 'canceled',
  COMPLETED: 'completed',
};

export const COMPLETED_STATUSES = [
  TODO_STATUSES.CANCELED,
  TODO_STATUSES.COMPLETED,
];

export const APPOINTMENT_CHANNEL_ID = 'appointment_channel';
export const APPOINTMENT_MENU = {
  type: 'system',
  channelName: 'apointments',
  blocked: false,
  lastMessage: {},
  channelId: APPOINTMENT_CHANNEL_ID,
  icon: 'icon-appointments',
  title: { id: 'healthboard.title.appointments' },
};

export const OFFICE_VISIT_TYPE_CODE = 'O';
export const URGENT_VISIT_TYPE_CODE = 'E';
export const VIRTUAL_VISIT_TYPE_CODE = 'W';
export const AW_TYPE_CODE = 'V';
export const KIOSK_TYPE_CODE = 'K';
export const URGENT_CARE_TYPE_CODE = 'U';
export const IMAGING_TYPE_CODE = 'R';
export const LAB_TYPE_CODE = 'L';
export const TECH_CONNECT_CODE = 'T';
export const PUBLIX_CODE = 'P';
export const HOLD_MY_SPOT_VISIT_TYPE_CODE = 'EIR-HMS';
export const TELEMEDICINE_VISIT_TYPE_CODE = 'EIR-TM';

export const SOURCE_OF_CREATION = {
  EIR: 'eir',
  APP: 'app',
  KIOSK: 'kiosk',
  PWS: 'pws',
  QR_KIOSK: 'qr-kiosk',
  PWS_WALK_IN: 'pws-walk-in',
};

export const WALK_IN_SOURCES = [
  SOURCE_OF_CREATION.KIOSK,
  SOURCE_OF_CREATION.QR_KIOSK,
  SOURCE_OF_CREATION.PWS_WALK_IN,
];

export const FORBIDDEN_VISIT_TYPES_FOR_MAP = [
  AW_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
  URGENT_VISIT_TYPE_CODE,
  TELEMEDICINE_VISIT_TYPE_CODE,
];

export const SHOW_ADDITIONAL_INFO_AFTER_TIME_SLOTS = [
  OFFICE_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
];

export const INLINE_TYPES = [
  URGENT_CARE_TYPE_CODE,
  IMAGING_TYPE_CODE,
  LAB_TYPE_CODE,
  TECH_CONNECT_CODE,
];

export const APPOINTMENT_ALLOWED_TYPES = [
  OFFICE_VISIT_TYPE_CODE,
  URGENT_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
  URGENT_CARE_TYPE_CODE,
  IMAGING_TYPE_CODE,
  LAB_TYPE_CODE,
  TECH_CONNECT_CODE,
  PUBLIX_CODE,
  HOLD_MY_SPOT_VISIT_TYPE_CODE,
  TELEMEDICINE_VISIT_TYPE_CODE,
];

export const APPOINTMENT_HIDDEN_TYPES = [KIOSK_TYPE_CODE];

export const EIR_APPOINTMENT_TYPES = [
  HOLD_MY_SPOT_VISIT_TYPE_CODE,
  TELEMEDICINE_VISIT_TYPE_CODE,
];

export const VIRTUAL_VISIT_EVENTS = {
  START_VISIT: 'start_visit',
  BREAK_VISIT: 'break_visit',
  FINISH_VISIT: 'finish_visit',
  DECLINE_VISIT: 'decline_visit',
};

export const INVITATION_TYPES = {
  FAMILY_MEMBER: 'FamilyMemberInvitation',
  GUARDIAN_PROXY: 'GuardianProxyInvitation',
  CAREGIVER: 'CaregiverInvitation',
};

export const TODO_TYPES = {
  INVITATION: 'invitation',
  SURVEY: 'survey',
  CONSENT: 'appointment_consents_assignment',
  TASK: 'todo_task_assignment',
  TASK_CUSTOM: 'todo_custom_task',
  CARE_PLAN_TASK: 'care_plan_task',
  PROGRAM: 'program_invitation',
  CONSENT_USER_ASSIGNMENT: 'consent_user_assignment',
};

export const REQUEST_HEADERS_OPTIONS = {
  SELECTED_TEAM: 'Selected-Team',
  ORGANIZATION_CODE: 'Organization-Code',
};

export const SUPPORTED_BROWSERS = [
  'Chrome',
  'Firefox',
  'Microsoft Edge',
  'Safari',
];

export const VISIT_TYPES = {
  imagining: 7,
  techConnect: 10,
};

export const PROVIDER_CALENDAR_SOURCE = 'provider_calendar';

export const APPOINTMENT_REQUEST_STATUS = {
  DECLINED: 'declined',
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
};

export const GLUCOSE_METRIC = {
  MG_PER_DECILITER: 'mg/dL',
  MMOL_PER_LITER: 'mmol/L',
};

export const WEIGHT_METRIC = {
  KG: 'kilograms',
  POUNDS: 'pounds',
};

export const HEIGHT_METRIC = {
  METERS: 'meters',
  FEET_INCHES: 'feet_and_inches',
};

export const TEMPERATURE_METRIC = {
  CELSIUS: 'celsius',
  FAHRENHEIT: 'fahrenheit',
};
export const STATUS_DEPENDENT_VERIFIED = 'verified';

export const PATIENT_ATTACHMENTS_TYPE = {
  DOCUMENTS: 'documents',
  OUTCOME_ATTACHMENTS: 'outcomeAttachments',
};

export const AUTH_AZURE_REDIRECT = {
  SIGN_UP: 'authorize-azure-sign-up-flow',
  SUCCESS: 'authorize-azure-success',
  ERROR: 'authorize-azure-error',
};

export const AUTH_AZURE_ERROR_CODE = {
  NOT_FOUND: 'record_not_found',
  NOT_CONFIRMED: 'login_email_not_confirmed',
  USER_DISABLED: 'user_disabled',
};

export const SUBSCRIBABLE_TYPE = {
  PROGRAM: 'program',
  LOCATION: 'location',
};

export const TRANSACTION_TYPE = {
  USER_SUBSCRIPTION: 'user_subscription',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  EXPIRED: 'expired',
  PENDING: 'pending',
  PREPAID: 'prepaid',
};

export const VIRTUAL_VISIT_INVITE_TYPE = {
  GUEST: 'guest',
  PATIENT: 'patient',
  IN_OFFICE: 'in-office',
  CONNECTION_ROOM: 'connection',
};

export const FEATURE_TOGGLE_CONFIG = {
  MEDICATION_REFILL: 'userMedicationRefills',
};

export const USA_POSTAL_CODE_EXAMPLES = '32909 or 32909-9125';

export const PATIENT_INSURANCE_STATUS = {
  DRAFT: 'draft',
  COMPLETED: 'completed',
};

export const EMPLOYER_NOT_LISTED_VALUE = 'EMPLOYER_NOT_LISTED';

export const DEPENDENT_FORM_SUBMIT_REDIRECT = {
  PROFILE: 'PROFILE',
  GET_CARE: 'GET_CARE',
};



// WEBPACK FOOTER //
// ./src/constants/index.js